import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import axios from '../libs/axios';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const location = useLocation();

  // Capture token from ?token=
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const t = params.get('token');
    if (t && onLogin) {
      onLogin(t);
      window.history.replaceState({}, document.title, location.pathname);
    }
  }, [location.search, location.pathname, onLogin]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await axios.post('/auth/login', { email, password });
      onLogin(res.data.access_token);
    } catch (err) {
      const msg = err?.response?.data?.detail || err?.message || 'Login failed';
      setError(msg);
    }
  };


  return (
    <AuthLayout
      title="Welcome back"
      subtitle="Enter your credentials to access your account"
      footer={(<p>Don't have an account? <Link className="link" to="/signup">Create one</Link></p>)}
    >
      {error && <div className="alert error">{error}</div>}
      <form onSubmit={handleSubmit} className="form">
        <label className="label">Email</label>
        <input className="input" type="email" placeholder="you@company.com" value={email} onChange={(e) => setEmail(e.target.value)} />
        <label className="label">Password</label>
        <input className="input" type="password" placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button className="btn-primary" type="submit">Sign in</button>
      </form>
    </AuthLayout>
  );
}
